import React from "react";

const EventsIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21.183"
      height="20.582"
      viewBox="0 0 21.183 20.582"
    >
      <g id="db3" transform="translate(-2.4 -3.8)">
        <path
          id="Path_1148"
          data-name="Path 1148"
          d="M21.812,13.1H20.075v.8a2.573,2.573,0,1,1-5.146,0v-.8h-3.7v.8a2.573,2.573,0,1,1-5.146,0v-.8H4.349A1.844,1.844,0,0,0,2.5,14.949V18.4H23.661V14.949A1.859,1.859,0,0,0,21.812,13.1Z"
          transform="translate(-0.078 -7.228)"
          fill={fill ? fill : "#000"}
        />
        <path
          id="Path_1149"
          data-name="Path 1149"
          d="M25.768,7.943a1.269,1.269,0,0,0,1.27-1.27V5.07a1.27,1.27,0,1,0-2.539,0v1.6A1.242,1.242,0,0,0,25.768,7.943Z"
          transform="translate(-17.175)"
          fill={fill ? fill : "#000"}
        />
        <path
          id="Path_1150"
          data-name="Path 1150"
          d="M65.37,7.943a1.269,1.269,0,0,0,1.27-1.27V5.07a1.27,1.27,0,1,0-2.539,0v1.6A1.255,1.255,0,0,0,65.37,7.943Z"
          transform="translate(-47.956)"
          fill={fill ? fill : "#000"}
        />
        <path
          id="Path_1151"
          data-name="Path 1151"
          d="M2.422,52.768a1.844,1.844,0,0,0,1.849,1.849H21.712a1.844,1.844,0,0,0,1.849-1.849V42.7H2.4V52.768Zm8-5.1,1.381-.2a.265.265,0,0,0,.223-.178l.6-1.225a.42.42,0,0,1,.735,0l.624,1.27a.354.354,0,0,0,.223.178l1.359.2a.4.4,0,0,1,.223.691l-1,.98a.306.306,0,0,0-.089.267l.223,1.359a.4.4,0,0,1-.579.423l-1.247-.646a.33.33,0,0,0-.29,0l-1.2.646a.4.4,0,0,1-.579-.423l.245-1.381a.306.306,0,0,0-.089-.267L10.2,48.4A.436.436,0,0,1,10.419,47.667Z"
          transform="translate(0 -30.235)"
          fill={fill ? fill : "#000"}
        />
      </g>
    </svg>
  );
};

export default EventsIcon;
